/**
 * Soft mouse parallax for editorial images.
 * Progressive: no-op without fine pointer or when reduced motion is on.
 */
(() => {
  const ATTR = 'data-sanctale-parallax';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');
  const max = 18;

  const bind = (root) => {
    const image =
      root.querySelector('[data-sanctale-parallax-image]') || root.querySelector('img');
    if (!image || root.getAttribute('data-sanctale-parallax-bound') === 'true') return;
    root.setAttribute('data-sanctale-parallax-bound', 'true');

    let frame = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const render = () => {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      image.style.transform =
        'translate3d(' +
        currentX.toFixed(2) +
        'px, ' +
        currentY.toFixed(2) +
        'px, 0) scale(1.08)';
      frame = requestAnimationFrame(render);
    };

    const onMove = (event) => {
      const rect = root.getBoundingClientRect();
      const px = (event.clientX - rect.left) / rect.width - 0.5;
      const py = (event.clientY - rect.top) / rect.height - 0.5;
      targetX = px * max * -1;
      targetY = py * max * -1;
    };

    const onLeave = () => {
      targetX = 0;
      targetY = 0;
    };

    const enable = () => {
      if (reduceMotion.matches || !finePointer.matches) {
        cancelAnimationFrame(frame);
        frame = 0;
        image.style.transform = '';
        root.removeEventListener('pointermove', onMove);
        root.removeEventListener('pointerleave', onLeave);
        return;
      }

      root.addEventListener('pointermove', onMove);
      root.addEventListener('pointerleave', onLeave);
      if (!frame) frame = requestAnimationFrame(render);
    };

    enable();
    reduceMotion.addEventListener('change', enable);
    finePointer.addEventListener('change', enable);
  };

  const init = () => {
    document.querySelectorAll(`[${ATTR}]`).forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
